
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getWaterQuotaPage } from '@/api/record'
import UserNameRemark from '@/components/UserNameRemark/index.vue'
import { UserModule } from '@/store/modules/user'

@Component({ name: 'UserWaterQuotaManage', components: { UserNameRemark } })
export default class extends Vue {
  private loading = false
  private list: any[] = []
  private total = 0
  private query = {
    pageNum: 1,
    pageSize: 10,
    userPhone: '',
    userName: '',
    onlyRemaining: true
  }

  get currentStoreId(): number | null {
    const sid = UserModule.storeId
    if (!sid) return null
    const n = Number(sid)
    return Number.isNaN(n) ? null : n
  }

  @Watch('currentStoreId')
  private onStoreChange() {
    this.query.pageNum = 1
    this.loadList()
  }

  mounted() { this.loadList() }

  private async loadList() {
    if (this.currentStoreId == null) {
      this.list = []
      this.total = 0
      return
    }
    this.loading = true
    try {
      const params: any = {
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize,
        storeId: this.currentStoreId,
        onlyRemaining: !!this.query.onlyRemaining
      }
      if (this.query.userPhone) params.userPhone = this.query.userPhone.trim()
      if (this.query.userName) params.userName = this.query.userName.trim()
      const res: any = await getWaterQuotaPage(params)
      if (String(res.data.code) === '1' && res.data.data) {
        this.list = res.data.data.records || []
        this.total = res.data.data.total || 0
      } else {
        this.list = []
        this.total = 0
      }
    } finally {
      this.loading = false
    }
  }

  private tableIndex(index: number) {
    return (this.query.pageNum - 1) * this.query.pageSize + index + 1
  }

  private handleSearch() { this.query.pageNum = 1; this.loadList() }
  private handleReset() {
    this.query = {
      pageNum: 1,
      pageSize: 10,
      userPhone: '',
      userName: '',
      onlyRemaining: true
    }
    this.loadList()
  }
}
